module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.logoShow),
      expression: "logoShow"
    }],
    staticClass: "brand"
  }, [(_vm.type === 1) ? _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    attrs: {
      "to": "/shopManagePage/enquiry"
    }
  }, [_c('i', {
    staticClass: "icon-dangkou"
  }), _vm._v(" "), _c('span', [_vm._v("网店管理")])]) : _c('router-link', {
    attrs: {
      "to": "/homePage"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/log.png"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "search-wrapper"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "concat",
    attrs: {
      "id": "concat"
    }
  }, [_c('div', {
    staticClass: "tel"
  }, [_vm._v("400-801-3357")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('i', {
    staticClass: "iconfont icon-kefu"
  }), _vm._v(" "), _c('span', [_vm._v("免费热线")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-9f1b5590"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = 852
// module chunks = 39